<script setup>
  import { NModal } from 'naive-ui'
  import { version } from '/package.json'
  import { ref, inject } from 'vue'

  const appName = import.meta.env.VUE_APP_NAME
  const appStoreFn = inject('appStoreFn')
  const appStore = appStoreFn()
  const year = ref(new Date().getUTCFullYear())
</script>
<template>
  <NModal
    v-model:show="appStore.showAboutModal"
    :mask-closable="false"
    preset="dialog"
    title="About"
  >
    <span class="items-center">
      <b> {{ appName }}- Version {{ version }} </b>
      <br /><br />
    </span>
    <span class="items-center"> &copy; {{ year }} American RFID Solutions, LLC. All Rights Reserved. </span>
  </NModal>
</template>
